import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import SftpDatumItem from '../../../Domain/SftpDatumItem';
import SftpDatumService from '../../../Services/SftpDatumService';

// Drives the GeneralEditWizzardBaseFigma edit wizard for SFTP servers. Single page
// with >6 fields renders as the full-screen DS wizard modal (no section nav).
export default class SftpWindowDescription {
  static titleForCreate = 'Add New Sftp';
  static titleForEdit = 'Edit Sftp';
  static entityName = 'Sftp';
  static idField = 'SftpDataId';
  static nameField = 'ServerName';
  static itemType = SftpDatumItem;
  static serviceFunction = SftpDatumService.EditSftpDatum;
  static messageOnSuccess = 'Sftp has been saved.';
  static finishButtonLabel = 'Save Sftp';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'ServerName',
          label: 'Server Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'IsActive',
          label: 'Is Active',
          className: 'col-6',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'DeleteDownloadedFiles',
          label: 'Delete Downloaded Files',
          className: 'col-6',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'Host',
          label: 'Host',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Port',
          label: 'Port',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'PathOnTheServer',
          label: 'Path On The Server',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'UserName',
          label: 'User Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Password',
          label: 'Password',
          className: 'col-6',
          type: InputTypesEnum.Text,
          placeholder: SftpWindowDescription.getPlaceholderForPassword,
          validityChecker: SftpWindowDescription.validityCheckerForPassword,
        },
      ],
    },
  ];

  static getPlaceholderForPassword(editedItem) {
    if (editedItem.SftpDataId) return 'Leave it empty to use the current password!';
    return '';
  }

  static validityCheckerForPassword(value, editedItem) {
    if (editedItem && editedItem.SftpDataId) return '';
    return ValidityHelper.forRequiredTextField(value);
  }
}
